import { h } from 'preact'

interface SingleOptionProps {
  option: string
  optionName: string
  handleSetClickedOption: (option: string) => void
}

const SingleOption = ({ option, optionName, handleSetClickedOption }: SingleOptionProps) => {
  return (
    <div
      className="calc-widget__single-option"
      role="button"
      tabIndex={0}
      onClick={() => handleSetClickedOption(option)}
      onKeyDown={(e) => e.key === 'Enter' && handleSetClickedOption(option)}
    >
      {optionName}
    </div>
  )
}

export default SingleOption
